import { useSession } from "@saas/auth/hooks/use-session";
import { useCredits } from "@saas/credits/hooks/use-credits";
import { useEffect, useRef } from "react";
import type { VideoHistoryItem } from "./types";

/** 跨页带着整条记录走：和生图页、My Assets 跳 /image-to-video 同一个 key，那边早就会接 */
export const VIDEO_ACTION_STORAGE_KEY = "videoActionData";

export type VideoHistoryAction = "reprompt" | "regenerate";

/**
 * 接别的页面跳过来的那条记录。等会话和积分都加载完再接：Regenerate 要登录态，还要比剩余积分，
 * 积分没回来时按 0 算会误弹积分不足（10/23 e2e 查出，从营销热梗页硬跳过来必中）。
 * /image-to-video 有自己的一份（ImageToVideoClient），这里给特效页和热梗页的 hero 用。
 * 单独一个文件：hero 也给首页用，别让首页为了它加载整份特效目录
 */
export function useIncomingVideoAction(
	onAction: (item: VideoHistoryItem, action: VideoHistoryAction) => void,
	enabled = true,
) {
	const { loaded } = useSession();
	const { isLoading: creditsLoading } = useCredits();
	const onActionRef = useRef(onAction);
	onActionRef.current = onAction;
	const handledRef = useRef(false);
	useEffect(() => {
		if (!enabled || !loaded || creditsLoading || handledRef.current) {
			return;
		}
		handledRef.current = true;
		const action = new URLSearchParams(window.location.search).get(
			"action",
		);
		if (action !== "reprompt" && action !== "regenerate") {
			return;
		}
		const raw = sessionStorage.getItem(VIDEO_ACTION_STORAGE_KEY);
		if (!raw) {
			return;
		}
		sessionStorage.removeItem(VIDEO_ACTION_STORAGE_KEY);
		try {
			onActionRef.current(JSON.parse(raw) as VideoHistoryItem, action);
		} catch {
			// 数据坏了就当没跳转过，用户还能手动填
		}
	}, [enabled, loaded, creditsLoading]);
}
